import { ApplicationEvent } from './application-event.model';
import { ApplicationAuthorizationActionType as AuthType, ApplicationEventType } from '../constants';

export class IdamRegisterApplicationEvent implements ApplicationEvent {

  type = ApplicationEventType.Authorization;

  constructor(
    private event?: string,
    private action?: AuthType,
    private label?: string,
    private category= 'Authorisation',
  ) {
  }

  getPayload(): any {
    return {
      event: this.event,
      category: this.category,
      action: this.action,
      label: this.label,
    };
  }
}
